<div class="wrapper">
  <div class="content-wrapper">
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>